module.exports = __webpack_public_path__ + "static/img/284_phase_function_Paper_Points.c4371a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/284_phase_function_Paper_Points.png
// module id = 4kCp
// module chunks = 0